/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useContext } from 'react';

import {
  StyledArrowBackIcon,
  StyledArrowForwardIcon,
  StyledDoneIcon,
  StyledNavButton,
} from 'components/DeclarationForm/DeclarationNavigation/NavButtons/styles';
import { StyledContainer } from 'components/DeclarationForm/DeclarationNavigation/styles';
import { ICustomTheme } from 'interfaces';

import { QuizContext } from '../useQuizForm';
import { StyledSubmitLoader } from './styles';

export function QuizNavigation(): JSX.Element {
  const {
    isFirstStep,
    isLastStep,
    goPrevStep,
    goNextStep,
    isCurrentStepValid,
    isSubmitting,
  } = useContext(QuizContext);

  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleForward = () => {
    // Second click while the entry is being sent: ignore it so the answer is
    // never submitted twice (the button is also disabled below).
    if (isSubmitting) return;

    if (isLastStep) {
      // Trigger the hidden submit button inside the <form>
      const btn = document.getElementById(
        'quiz-submit-btn',
      ) as HTMLButtonElement | null;
      if (btn) btn.click();
    } else {
      goNextStep();
    }
  };

  return (
    <StyledContainer isMobile={isMobile} hasResultEntryEnabled={false}>
      {!isFirstStep && (
        <StyledNavButton
          onClick={goPrevStep}
          disabled={isSubmitting}
          variant="contained"
          type="button"
          disableElevation
          backgroundColor={theme.colors.grey.main}
          isMobile={isMobile}
        >
          <StyledArrowBackIcon />
        </StyledNavButton>
      )}
      <StyledNavButton
        onClick={handleForward}
        disabled={!isCurrentStepValid || isSubmitting}
        aria-busy={isSubmitting}
        variant="contained"
        type="button"
        disableElevation
        backgroundColor={theme.colors.paletteFromBO.primary}
        isMobile={isMobile}
      >
        {isSubmitting && <StyledSubmitLoader size={24} />}
        {!isSubmitting &&
          (isLastStep ? <StyledDoneIcon /> : <StyledArrowForwardIcon />)}
      </StyledNavButton>
    </StyledContainer>
  );
}
